export default "__VITE_ASSET__DqQdSfNT__"